<template>
  <v-sheet tile class="fill-height" align="center">
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <div class="title">Page doesn't exists</div>
        </v-col>
        <v-col cols="12" align="center" justify="center">
          <v-btn color="primary" :to="getDefaultPage">Go Home</v-btn>
        </v-col>
        <v-col cols="12" align="center" justify="center">&nbsp;</v-col>
        <v-col cols="12" align="center" justify="center">&nbsp;</v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Error404Page",
    computed: {
      ...mapGetters(['getDefaultPage'])
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Pages/Error404Page.vue